/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('UtpBrandServiceApi', ($http, ApiErrorService) => {
    return {
        saveBrand: saveBrand,
        getAllUnbrandedSims: getAllUnbrandedSims,
        getAllBrandsAndSims: getAllBrandsAndSims,
        saveBrandDTO: saveBrandDTO
    };
    function saveBrand(brand) {
        return $http.post(`api/UTPBrand/SaveBrand`, brand)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllUnbrandedSims() {
        return $http.get(`api/UTPBrand/GetAllUnbrandedSims`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllBrandsAndSims() {
        return $http.get(`api/UTPBrand/GetAllBrandsAndSims`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveBrandDTO(dto) {
        return $http.post(`api/UTPBrand/SaveBrandDTO`, dto)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
